import {Component, ElementRef, EventEmitter, Input, Output, Renderer2} from '@angular/core';
import {Util} from "../../app/util";
import {ENUM, TPaybookTipo, TPaybookFlag} from "../../app/enum";
import {CONFIG} from "../../app/config";
import {LogadoService} from "../../providers/logado-service";


@Component({
    selector: 'app-payout',
    templateUrl: 'app-payout.html'
})

export class AppPayout {

    ENUM: any = ENUM;
    config: any;
    logado: any;

    cardpin: number;

    TPaybookTipo: any = TPaybookTipo;
    TPaybookFlag: any = TPaybookFlag;

    @Input('userset') public userset: any;
    @Input('checkin') public checkin: any;
    @Input('fronter') public fronter: false | true | 'noro';
    @Input('fliprun') public fliprun: boolean;
    @Input('pagapay') public pagapay: false | true | 'x' | 'eye';

    @Output('payout-edita') private _edita: EventEmitter<any> = new EventEmitter();
    @Output('payout-click') private _click: EventEmitter<any> = new EventEmitter();
    @Output('payout-press') private _press: EventEmitter<any> = new EventEmitter();
    @Output('payout-botao') private _botao: EventEmitter<any> = new EventEmitter();
    @Output('payout-photo') private _photo: EventEmitter<any> = new EventEmitter();

    constructor(public util: Util, public element: ElementRef, public renderer: Renderer2,
                public logadoService: LogadoService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        //this._element = element.nativeElement;

    }

    ngOnInit() {

        if (!this.checkin) {
            this.util.alertSimply('payout-gateway Undefined!', 'Developer Error');
            return;
        }

    }

    paybookTime(flug: 'time') {

        if (flug == 'time') {
            let cria = this.util.horatime(this.checkin.PaybookCria);
            let bora = this.util.horatime(this.checkin.PaybookBora);
            return cria + (bora ? ' até ' + bora : '');
        }

    }

    paybookLock(): string {

        if (this.checkin.PaybookFlag == TPaybookFlag.pfWalk) return 'Espera';
        if (this.checkin.PaybookFlag == TPaybookFlag.pfBill) return 'Pré-conta';
        if (this.checkin.PaybookFlag == TPaybookFlag.pfLock) return 'Travado';
        return '';

    }

    paybookNoro() {

        let result = '';
        if (this.checkin.PaybookTipo == TPaybookTipo.pbMesa) result = 'Mesa'; 
        if (this.checkin.PaybookTipo == TPaybookTipo.pbSend) result = 'Entrega';
        if (this.checkin.PaybookTipo == TPaybookTipo.pbTake) result = 'Retirar';
        return (result + ' ' + this.util.numerico(this.checkin.PaybookNoro, 4)).trim();

    }

    ambientText() {

        //#GAMB - ProdutoTipo.ptConvite - DESK
        let consumo = this.checkin.Consumos.forEach(CS => CS.Produto.ProdutoTipo == 8);
        if (consumo) return '<b>' + this.checkin.Ambient.AmbientNome + '</b>' + ' ' + consumo.ConsumoText;

        return '<b>' + this.checkin.Ambient.AmbientNome + '</b>';
        
    }

    fliprunVira() {

        this.util.impact();

        let className = (this.fronter ? 'flipOutYInvert' : 'flipOutY');
        this.renderer.addClass(this.element.nativeElement, className);
        setTimeout(() => {
            this.fronter = !this.fronter;
            this.renderer.removeClass(this.element.nativeElement, className);
        }, 750);

    }

    _emitClick(item) {

        // inicia animacao
        if (this.fliprun) this.fliprunVira();

        this._click.emit(item);

    }

    _emitPress(item) {

        this._press.emit(item);

    }

    _emitBotao(item, event?) {

        if (event) event.stopPropagation();
        this._botao.emit(item);

    }

    _emitPhoto(event?) {

        // inicia animacao
        if (this.fliprun) this.fliprunVira();

        if (event) event.stopPropagation();
        this._photo.emit(this.checkin.Profile);

    }

    _emitEdita(event, paybookNoro) {

        if (event) event.stopPropagation();
        this._edita.emit(paybookNoro);

        this.cardpin = null;

    }


}



// WEBPACK FOOTER //
// ./src/components/app-payout/app-payout.ts